import React from 'react';
import CreateEventForm from '../events/CreateEventForm';
import './CreateEventPopup.css';

function CreateEventPopup({ onClose, onSuccess }) {
  const handleSuccess = (eventData) => {
    if (onSuccess) {
      onSuccess(eventData);
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="create-event-popup create-event-popup--shell">
      <CreateEventForm compact onClose={onClose} onSuccess={handleSuccess} />
    </div>
  );
}

export default CreateEventPopup;
